import { render, staticRenderFns } from "./SummarizedTimeline.vue?vue&type=template&id=145a9d67"
import script from "./SummarizedTimeline.vue?vue&type=script&lang=js"
export * from "./SummarizedTimeline.vue?vue&type=script&lang=js"
import style0 from "./SummarizedTimeline.vue?vue&type=style&index=0&id=145a9d67&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports